const prepareShow = addresses => {
  return addresses
}

export default {
  prepareShow
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/resources/methods.js